import { Component, Input } from '@angular/core';

@Component({
    selector: 'icon-cardiogram',
    templateUrl: './cardiogram.component.html',
    styleUrls: ['./cardiogram.component.css'],
    standalone: false
})
export class CardiogramComponent {
  @Input() size = 24;
  @Input() color = '#000';
}
